"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var types_generated_exports = {};
__export(types_generated_exports, {
  isApiError: () => isApiError,
  isBadRequestError: () => isBadRequestError,
  isDuplicateError: () => isDuplicateError,
  isExpiredAuthorizationError: () => isExpiredAuthorizationError,
  isForbiddenError: () => isForbiddenError,
  isInternalError: () => isInternalError,
  isInvalidAuthorizationError: () => isInvalidAuthorizationError,
  isMapQueryUnsupportedError: () => isMapQueryUnsupportedError,
  isMissingAuthorizationError: () => isMissingAuthorizationError,
  isNetworkError: () => isNetworkError,
  isNotFoundError: () => isNotFoundError,
  isValidationError: () => isValidationError
});
module.exports = __toCommonJS(types_generated_exports);
var import_types_generated = require("../core/types.generated.js");
var import_types_generated2 = require("../permission/types.generated.js");
const isExpiredAuthorizationError = (v) => {
  return typeof v === "object" && v != null && (!("timestamp" in v) || (0, import_types_generated.isTimestamp)(v.timestamp) || v.timestamp === null);
};
const isInvalidAuthorizationError = (v) => {
  return typeof v === "object" && v != null && (!("timestamp" in v) || (0, import_types_generated.isTimestamp)(v.timestamp) || v.timestamp === null);
};
const isMissingAuthorizationError = (v) => {
  return typeof v === "object" && v != null && (!("timestamp" in v) || (0, import_types_generated.isTimestamp)(v.timestamp) || v.timestamp === null);
};
const isForbiddenError = (v) => {
  return typeof v === "object" && v != null && (!("userId" in v) || (0, import_types_generated.isUserId)(v.userId) || v.userId === null) && (!("roles" in v) || Array.isArray(v.roles) && v.roles.every((i) => (0, import_types_generated2.isRole)(i)) || v.roles === null) && (!("qualificationRoles" in v) || Array.isArray(v.qualificationRoles) && v.qualificationRoles.every((i) => (0, import_types_generated2.isQualificationRole)(i)) || v.qualificationRoles === null) && "check" in v && (0, import_types_generated2.isPermissionCheck)(v.check) && (!("timestamp" in v) || (0, import_types_generated.isTimestamp)(v.timestamp) || v.timestamp === null);
};
const isBadRequestError = (v) => {
  return typeof v === "object" && v != null && "message" in v && typeof v.message === "string" && "extraData" in v && true && (!("timestamp" in v) || (0, import_types_generated.isTimestamp)(v.timestamp) || v.timestamp === null);
};
const isNotFoundError = (v) => {
  return typeof v === "object" && v != null && "itemType" in v && typeof v.itemType === "string" && "item" in v && typeof v.item === "string" && (!("timestamp" in v) || (0, import_types_generated.isTimestamp)(v.timestamp) || v.timestamp === null);
};
const isDuplicateError = (v) => {
  return typeof v === "object" && v != null && "itemType" in v && typeof v.itemType === "string" && "item" in v && typeof v.item === "string" && (!("timestamp" in v) || (0, import_types_generated.isTimestamp)(v.timestamp) || v.timestamp === null);
};
const isMapQueryUnsupportedError = (v) => {
  return typeof v === "object" && v != null && "layerId" in v && (0, import_types_generated.isMapLayerId)(v.layerId) && "message" in v && typeof v.message === "string" && (!("timestamp" in v) || (0, import_types_generated.isTimestamp)(v.timestamp) || v.timestamp === null);
};
const isInternalError = (v) => {
  return typeof v === "object" && v != null && "message" in v && typeof v.message === "string" && (!("timestamp" in v) || (0, import_types_generated.isTimestamp)(v.timestamp) || v.timestamp === null);
};
const isValidationError = (v) => {
  return typeof v === "object" && v != null && "value" in v && true && "errors" in v && Array.isArray(v.errors) && v.errors.every((i) => (0, import_types_generated.isMessage)(i)) && "message" in v && typeof v.message === "string" && "status" in v && typeof v.status === "number" && (!("timestamp" in v) || (0, import_types_generated.isTimestamp)(v.timestamp) || v.timestamp === null);
};
const isNetworkError = (v) => {
  return typeof v === "object" && v != null && "extraData" in v && true && "message" in v && typeof v.message === "string" && (!("timestamp" in v) || (0, import_types_generated.isTimestamp)(v.timestamp) || v.timestamp === null);
};
const isApiError = (v) => {
  return typeof v === "object" && v != null && "type" in v && (v.type === "ExpiredAuthorizationError" && isExpiredAuthorizationError(v) || v.type === "InvalidAuthorizationError" && isInvalidAuthorizationError(v) || v.type === "MissingAuthorizationError" && isMissingAuthorizationError(v) || v.type === "ForbiddenError" && isForbiddenError(v) || v.type === "BadRequestError" && isBadRequestError(v) || v.type === "NotFoundError" && isNotFoundError(v) || v.type === "DuplicateError" && isDuplicateError(v) || v.type === "MapQueryUnsupportedError" && isMapQueryUnsupportedError(v) || v.type === "InternalError" && isInternalError(v) || v.type === "ValidationError" && isValidationError(v) || v.type === "NetworkError" && isNetworkError(v));
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  isApiError,
  isBadRequestError,
  isDuplicateError,
  isExpiredAuthorizationError,
  isForbiddenError,
  isInternalError,
  isInvalidAuthorizationError,
  isMapQueryUnsupportedError,
  isMissingAuthorizationError,
  isNetworkError,
  isNotFoundError,
  isValidationError
});
//# sourceMappingURL=types.generated.js.map
